module.exports = __webpack_public_path__ + "img/emoji-sunglasses.f2f7762c.svg";